import { ReactNode, createContext, useContext } from 'react'

import useSensitiveDataFlag from '@utils/useSensitiveDataFlag'

const SensitiveDataContext = createContext<boolean | undefined>(undefined)

export const SensitiveDataProvider = ({ children }: { children: ReactNode }) => {
  const sensitiveDataFlag = useSensitiveDataFlag()
  return (
    <SensitiveDataContext.Provider value={sensitiveDataFlag}>
      {children}
    </SensitiveDataContext.Provider>
  )
}

export const useSensitiveData = () => {
  const ctx = useContext(SensitiveDataContext)
  if (ctx === undefined) {
    throw new Error('useSensitiveData must be used within a SensitiveDataProvider')
  }
  return ctx
}
